import { DefaultComment, Comment } from "./Comment";
import { DefaultTicketApproval, TicketApproval } from "./ticketApproval/TicketApproval";
import { DefaultTicketUARFields, UARFields } from "./UARFields";
import { Attachment } from "./ticketAttachments/Attachment";

export interface Ticket {
  id: string;
  module: string;
  ticketTypes: string[];
  title: string;
  description: string;
  priority: string;
  status: string;
  assignee: string;
  createdBy: string;
  createdDate: string;
  updatedBy: string;
  dueDate: string;
  comments: Comment[];
  attachments: Attachment[];
  UARFields: UARFields;
  approvals?: TicketApproval[];
}

export function DefaultTicket(): Ticket {  return {
    id: '',
    module: '',
    ticketTypes: [],
    title: '',
    description: '',
    priority: '',
    status: '',
    assignee: '',
    createdBy: '',
    createdDate: '',
    updatedBy: '',
    dueDate: '',
    comments: [DefaultComment()],
    attachments: [],
    UARFields: DefaultTicketUARFields(),
    approvals: [DefaultTicketApproval()]
  };
}
